import { DroneStatusType } from "@src/core/features";

export interface ToggleCollapseViewProps {
  status: Extract<DroneStatusType, 'IDLE' | 'MISSION'>;
  children: React.ReactNode;
  count?: number;
}

export const DroneStatusColors: Record<Extract<DroneStatusType, 'IDLE' | 'MISSION'>, string> = {
  [DroneStatusType.IDLE]: 'success.main',
  [DroneStatusType.MISSION]: 'info.main',
};

export const DroneStatusNames: Record<Extract<DroneStatusType, 'IDLE' | 'MISSION'>, string> = {
  [DroneStatusType.IDLE]: 'IDLE',
  [DroneStatusType.MISSION]: 'MISSION',
};

